import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllMasterTM = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/getAll`);
};

export const getAllMasterTMLimit200 = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/getAllLimit200`);
};

export const getMasterTMById = (id) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/getById/${id}`);
};

export const getByFileNoTmMatter = (file_no) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/get-by-fileno/${file_no}`);
};

export const getMasterTMSearch = (query) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/searchdata`, query);
};

export const getMasterTMFileNoSearch = (searchapplication_no) => {
  return httpClient.get(
    `${trademark_const.trademark_url}/` + server.MASTERTM + `/getapplication_no/${searchapplication_no}`
  );
};

export const createMasterTM = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.MASTERTM, data);
};
export const createMasterTMV2 = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.MASTERTM + `/v2`, data);
};

export const updateMasterTM = (mastertm_id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/${mastertm_id}`, data);
};
export const updateMasterTMDel = (mastertm_id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/del/${mastertm_id}`, data);
};
export const updateMasterTMV2 = (mastertm_id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/v2/${mastertm_id}`, data);
};

export const deleteMasterTM = (id) => {
  return httpClient.delete(`${trademark_const.trademark_url}/` + server.MASTERTM + `/${id}`);
};

export const getfile_no = (searchfile_no) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/getfile_no/${searchfile_no}`);
};

export const getAllMasterTMPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  search,
  tmstatusasoff,
  datadatefrom,
  datadateto,

) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/getMasterTMPagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      search,
      tmstatusasoff,
      datadatefrom,
      datadateto,
    }
  });
};


export const gteTMFileNoSearch = () => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/file-no-search`);
};
export const CheckTMFileNo = (fileno) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/check-tm-fileno/${fileno}`);
};
export const CheckTMAppNp = (appno) => {
  return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERTM + `/check-tm-appno/${appno}`);
};
export const updateMasterTMByFileNo = (fileno, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/updateByFileNo/${fileno}`, data);
};

export const CreateFileMatterTm = (mastertm_id, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/create-file-matter-tm/${mastertm_id}`, data);
};
export const CreateNewTm = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.MASTERTM + `/create-new-tm`, data);
};
export const UpdateNewTm = (masterid, data) => {
  return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERTM + `/update-new-tm/${masterid}`, data);
};


export const gettimelinemastertm = (data) => {
  return httpClient.post(`${trademark_const.trademark_url}/` + server.MASTERTM + `/gettimelinemastertm`, data);
};

